import { DataModel } from '../../dto/dto.js';
import { OutboundWebhookStrategy } from './outbound-webhook-strategy.js';

export abstract class OutboundWebhookProtocol extends DataModel {
  abstract get strategy(): OutboundWebhookStrategy;
}
